import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ActivityContainer from './components/ActivityContainer';
import usePage from '@monorepo/shared/src/hooks/use-page';
import ActivityAudioProvider from '@monorepo/shared/src/providers/ActivityAudioProvider';
import GameProvider from '@monorepo/shared/src/providers/GameProvider';
import HintProvider from '@monorepo/shared/src/providers/HintProvider';
import OverlayProvider from '@monorepo/shared/src/providers/OverlayProvider';
import { getActivitySelectionModalRoute } from '@monorepo/shared/src/util/navigation-util';

const Activities: React.FC = () => {
  const [, { resetPage }] = usePage();
  const { character, activityType } = useParams();

  useEffect(() => {
    return () => resetPage();
  }, []);

  return (
    <ActivityAudioProvider>
      <GameProvider character={character ?? ''} activityType={activityType ?? ''}>
        <OverlayProvider>
          <HintProvider>
            <ActivityContainer backRoute={getActivitySelectionModalRoute(character ?? '')} />
          </HintProvider>
        </OverlayProvider>
      </GameProvider>
    </ActivityAudioProvider>
  );
};

export default Activities;
